/**
 * @generated SignedSource<<ec82948bcf348061f270d7269a7cf47e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectVersionStatus = "AWAITING_APPROVAL" | "AWAITING_EVALUATION" | "AWAITING_VALIDATION" | "ERROR" | "OK";
import { FragmentRefs } from "relay-runtime";
export type SubmissionStatusBadgeFragment$data = {
  readonly evaluation: {
    readonly error: string | null | undefined;
    readonly finalizedAt: string | null | undefined;
    readonly max: boolean;
    readonly score: number | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly project: {
    readonly competition: {
      readonly noCode: boolean;
      readonly showMetric: boolean;
    };
  };
  readonly status: ProjectVersionStatus;
  readonly version: string;
  readonly " $fragmentType": "SubmissionStatusBadgeFragment";
};
export type SubmissionStatusBadgeFragment$key = {
  readonly " $data"?: SubmissionStatusBadgeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubmissionStatusBadgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectVersionEvaluation",
      "kind": "LinkedField",
      "name": "evaluation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "error",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalizedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "max",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Competition",
          "kind": "LinkedField",
          "name": "competition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showMetric",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectVersion",
  "abstractKey": null
};

(node as any).hash = "7cddaf5a2a9d5789354a366990853aac";

export default node;
